import { normalizeSearch } from '@cop/shared';
/** Preserve original spelling and map the first normalized match back to original code units. */
export function Highlight({ text, query }: { text: string; query: string }) {
  const q = normalizeSearch(query.trim());
  if (!q) return <>{text}</>;
  let normalized = '';
  const positions: number[] = [];
  let offset = 0;
  for (const char of text) {
    const fold = normalizeSearch(char);
    normalized += fold;
    for (let i = 0; i < fold.length; i++) positions.push(offset);
    offset += char.length;
  }
  const index = normalized.indexOf(q);
  if (index < 0) return <>{text}</>;
  const start = positions[index]!;
  const last = positions[index + q.length - 1]!;
  let end = last + (text.codePointAt(last)! > 0xffff ? 2 : 1);
  while (end < text.length && /\p{M}/u.test(text[end]!)) end++;
  return <>{text.slice(0, start)}<mark>{text.slice(start, end)}</mark>{text.slice(end)}</>;
}
